<template>
  <div v-if="store" id="locationTab">
    <p>
      {{
        store.street ||
          $store.getters['translations/getLabel']('LOCATION_NO_STREET')
      }},
      {{
        store.city ||
          $store.getters['translations/getLabel']('LOCATION_NO_CITY')
      }},
      {{
        store.region ||
          $store.getters['translations/getLabel']('LOCATION_NO_REGION')
      }},
      {{
        store.country ||
          $store.getters['translations/getLabel']('LOCATION_NO_COUNTRY')
      }}
      {{
        store.postcode ||
          $store.getters['translations/getLabel']('LOCATION_NO_POSTCODE')
      }}
    </p>
    <!-- Add map here -->
  </div>
</template>

<script>
import $api from '@/services/api';

export default {
  name: 'LocationTab',

  data() {
    return {
      store: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      $api.get(`/v1/dashboard/stores/${this.$route.params.id}`).then(store => {
        this.store = store;
      });
    },
  },
};
</script>
